<template>
	<div>
		<myheader :backFlag="true" :headTitle="title"></myheader>
		<!-- :backIntercept="true" @childBackEvent="back" 拦截返回按钮事件 -->
		<div class="forgot_content all_content">
			<div>
				<div class="all_input" :class="{ isfocus: telFocus }">
					<van-field v-model="phone" type="number" maxlength="11" placeholder="请输入手机号" clearable
						@focus="getFocus(1)" @blur="onblur(1)">
					</van-field>
					<!-- <input class="my_input text14 textcolor333" placeholder="手机号" v-model="phone" @focus="getFocus(1)"
						@blur="onblur(1)" /> -->
				</div>
				<div class="all_input" :class="{ isfocus: idcodeFocus }">
					<van-field v-model="idcode" type="text" maxlength="18" placeholder="请输入身份证号" clearable
						@focus="getFocus(2)" @blur="onblur(2)">
					</van-field>
				</div>
				<div class="all_input" :class="{ isfocus: passwordFocus }">
					<van-field v-model="password" :type="passwordType" maxlength="30" placeholder="请输入新密码" clearable
						@clear="passwordType = 'password'" @focus="getFocus(3)" @blur="onblur(3)"
						@keydown.enter="next()">
						<template v-if="password.length>0" slot="right-icon">
							<img style="width: 20px;object-fit: contain;margin-top: 5px;"
								:src="passwordType==='password'?showPass:hidePass" fill @click="switchPasswordType()">
						</template>
					</van-field>
				</div>
				<span class="text12 textcolor333">不少于8位，区分大小写，需要同时包含数字、字母、特殊字符</span>
				<div class="all_input" :class="{ isfocus: verifyFocus }">
					<div class="display_inline_block" style="width: 65%">
						<van-field type="number" :placeholder="verifyholder" v-model="verifyCode" @focus="getFocus(4)"
							@blur="onblur(4)" maxlength="6" clearable>
						</van-field>
					</div>
					<span @click="getPictureImg()" class="display_inline_block" title="看不清,换一个" style="width: 30%;">
						<img :src="verifyImg" style="height: 2rem;width: 5rem;" fill title="看不清,换一个" /></span>
				</div>
				<div class="all_input" :class="{ isfocus: codeFocus }">
					<div class="display_inline_block" style="width: 60%;">
						<van-field v-model="smsCode" type="number" maxlength="6" placeholder="请输入验证码" clearable
							@focus="getFocus(5)" @blur="onblur(5)" />
					</div>
					<span @click="getCode()" class="display_inline_block text14 all_text_right all_line_height20"
						style="width: 35%;" :class="{textcolormain:timer===60,textcolor999:timer!=60}">
						{{timer===60?'获取验证码':(timer+'s后再次获取')}}</span>
				</div>
			</div>
			<button class="all_button text14 bmain_active" style="margin-top: 1.5rem;"
				@click="findPwdCheck()">完成</button>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Field
	} from 'vant';
	//Vue.use(Field);
	export default {
		components: {
			[Field.name]: Field,
		},
		data() {
			return {
				title: '找回密码',
				//验证码倒计时
				timer: 60,
				//手机号
				phone: '',
				//验证码
				smsCode: '',
				//身份证号
				idcode: '',
				//密码
				password: '',
				//图片验证结果
				verifyCode: '',
				//验证Id
				verifyId: '',
				//验证图片
				verifyImg: '',
				telFocus: false,
				codeFocus: false,
				idcodeFocus: false,
				passwordFocus: false,
				verifyFocus: false,
				//默认显示
				verifyholder: '请输入计算结果',
				//密码可见
				passwordType: 'password',
				//显示
				showPass: require('../../assets/images/show_password.svg'),
				//隐藏
				hidePass: require('../../assets/images/hide_password.svg')
			}
		},
		methods: {
			//新密码显示
			switchPasswordType() {
				if (this.passwordType === 'password') {
					this.passwordType = 'text'
				} else {
					this.passwordType = 'password'
				}
			},
			// 获得焦点
			getFocus(id) {
				if (id == 1) {
					this.telFocus = true;
				} else if (id == 2) {
					this.idcodeFocus = true;
				} else if (id == 3) {
					this.passwordFocus = true;
				} else if (id == 4) {
					this.verifyFocus = true;
				} else if (id == 5) {
					this.codeFocus = true;
				}
			},
			// 失去焦点
			onblur(id) {
				if (id == 1) {
					this.telFocus = false;
				} else if (id == 2) {
					this.idcodeFocus = false;
				} else if (id == 3) {
					this.passwordFocus = false;
				} else if (id == 4) {
					this.verifyFocus = false;
				} else if (id == 5) {
					this.codeFocus = false;
				}
			},
			//获取认证图片
			getPictureImg() {
				this.verifyCode = ''
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/login/api/getPictureImg').then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.verifyId = res.data.verifyId
						this.verifyImg = res.data.srcImg
					} else {
						this.verifyImg = ''
						this.$Toast("未获取到验证图片！");
					}
				}).catch((err) => {
					this.verifyImg = ''
					this.$store.dispatch(this.$LoadShow, false)
					console.log('getPictureImg', err)
				});
			},
			//找回密码核查
			findPwdCheck() {
				this.phone = this.phone.trim()
				//修改密码
				this.password = this.password.trim()
				//获取身份证号
				this.idcode = this.idcode.trim()
				this.smsCode = this.smsCode.trim()
				//验证手机号
				let reg = /^1[0-9]{10}$/;
				if (
					this.phone &&
					this.phone.length == 11 &&
					reg.test(this.phone)
				) {
					if (!this.idcode) {
						this.$Toast("请输入身份证号！");
						return
					}
					if (this.idcode.length < 18) {
						this.$Toast("请输入18位身份证号！");
						return
					}
					let idcodeReg18 = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/;
					if (!idcodeReg18.test(this.idcode)) {
						this.$Toast("请检查身份证号是否正确！");
						return
					}
					let exp = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*;?:])[\da-zA-Z~!@#$%^&*;?:]{8,}$/;
					if (!this.password) {
						this.$Toast("请输入密码！");
						return
					}
					if (this.password.length < 8) {
						this.$Toast("密码不能少于8位！");
						return
					}
					if (!exp.test(this.password)) {
						this.$Toast("密码需要同时包含数字、字母、特殊字符！");
						return
					}
					if (!this.smsCode) {
						this.$Toast("请输入验证码！");
						return
					}
					this.$store.dispatch(this.$LoadShow, true)
					this.$post(
						'/login/api/findPwdCheck',
						JSON.stringify({
							mobile: this.phone,
							idCode: this.idcode,
							password: this.password
						})
					).then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.findPwd()
						} else {
							this.$Toast(res.message || res.messageDetail || "请求失败，请重试！");
							this.getPictureImg()
						}
					}).catch((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						this.getPictureImg()
						console.log('findPwdCheck', res)
					})
				} else {
					this.$Toast("请输入正确的手机号！");
				}
			},
			//修改密码
			findPwd() {
				this.$post(
					'/login/api/findPwd',
					JSON.stringify({
						mobile: this.phone,
						idCode: this.idcode,
						password: this.password,
						smsCode: this.smsCode
					})
				).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast("修改密码成功！");
						this.$router.go(-1);
					} else {
						this.$Toast(res.message || res.messageDetail || "请求失败，请重试！");
						this.getPictureImg()
					}
				}).catch((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.getPictureImg()
					console.log('findPwd', res)
				})
			},
			//获取验证码
			getCode() {
				if (this.timer != 60) {
					return
				}
				this.phone = this.phone.trim()
				let reg = /^1[0-9]{10}$/;
				if (
					this.phone &&
					this.phone.length == 11 &&
					reg.test(this.phone)
				) {
					if (!this.verifyId || !this.verifyCode) {
						this.$Toast("请输入图片验证码计算结果！");
						return
					}
					this.smsCode = "";
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/login/api/sendSmsCode", JSON.stringify({
						mobile: this.phone,
						type: 2, //type：1 登录、2 忘记密码、3 重置密码、4 更换手机号 5、个人认证
						verify: {
							id: this.verifyId,
							code: this.verifyCode
						}
					})).then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.$Toast("验证码已发送，请注意查收！");
							this.timer--;
							var timer1 = setInterval(() => {
								this.timer--;
								if (this.timer == 0) {
									this.timer = 60;
									clearTimeout(timer1);
								}
							}, 1000);
						} else {
							this.$Toast(res.message || "获取验证码失败！");
							this.getPictureImg()
						}
					}).catch((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						this.getPictureImg()
						console.log('sendSmsCode', res)
					})
				} else {
					this.$Toast("请输入正确的手机号！");
				}
			},
			//返回上一步
			back(data) {}
		},
		mounted() {
			this.getPictureImg()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.forgot_content {
		position: relative;
		padding-top: 4rem;
		height: 100%;
		background-color: white;

		::v-deep .van-cell {
			padding: 10px .3rem;
		}


	}
</style>